/* eslint-disable jira/import-whitelist */
import { topNav4UIStateResource } from '@jira/navigation-apps__resources/src/services/top-nav/index.tsx';
import { sidebarEntryUiStateResource } from '@jira/navigation-apps__resources/src/services/sidebar-nav4/index.tsx';
import { navPlatformSidebarResource } from '@jira/nav-platform-integration__resources/src/navPlatformSidebarResource.tsx';
import { navPlatformRootStateResource } from '@jira/platform__controllers-layout/src/controllers/layout-controller/containers/layout-manager/navPlatformRootStateResource.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import { csmAppSidebarQueryResource } from './csmAppSidebarQueryResource.tsx';

export function getCustomerServiceL1NavigationResources(): RouteResource[] {
	return [
		// Loads the baseline SPA shell resources required by Jira routes.
		...jiraSpaResources(),

		// Top navigation
		topNav4UIStateResource,

		// Left navigation
		sidebarEntryUiStateResource,
		csmAppSidebarQueryResource,

		// Loads the Nav4 sidebar entry UI state for sidebar selection/rendering.
		navPlatformRootStateResource, // ?
		navPlatformSidebarResource, // ?
	];
}
